<template>
  <div>
    <dialog-zoomer v-on:close="lbHide" v-model="viz">
      <div class="message-panel">
        <div class="close-box" v-on:click="viz = false"></div>
        <div class="title">{{ $store.state.message.title }}</div>
        <div class="message">{{ $store.state.message.message}}</div>
        <div v-if="showOkCancel" class="mb-bpan">
          <small-button v-on:click="handleOk">OK</small-button>
          <small-button v-on:click="handleCancel">Cancel</small-button>
        </div>
      </div>
    </dialog-zoomer>
  </div>
</template>

<script>
import DialogZoomer from '@/components/dialogs/DialogZoomer.vue'
export default {
  components: {
    DialogZoomer
  },
  props: {
    showOkCancel: Boolean
  },
  data () {
    return {
      viz: false
    }
  },
  methods: {
    lbHide: async function () {
      this.$store.commit('hideMessage')
    },
    handleOk() {
      console.log('ok was clicked')
      this.viz = false
      this.$store.commit('hideMessage')
      this.$emit('ok')
    },
    handleCancel() {
      console.log('cancel was clicked')
      this.viz = false
      this.$store.commit('hideMessage')
      this.$emit('cancel')
    }
  },
  watch: {
    '$store.state.message.show': function () {
      console.log('MESSAGE-PANEL')
      if(this.$store.state.message.show){
        this.viz = true
      }
    }
    
  }
}
</script>

<style>
.mb-bpan{
  display:flex;
  margin:20px;
}
</style>
